/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FacilityIntegration } from './FacilityIntegration';
import {
    FacilityIntegrationFromJSON,
    FacilityIntegrationFromJSONTyped,
    FacilityIntegrationToJSON,
} from './FacilityIntegration';

/**
 * 
 * @export
 * @interface FindAllIntegrationsByFacilityId200Response
 */
export interface FindAllIntegrationsByFacilityId200Response {
    /**
     * 
     * @type {Array<FacilityIntegration>}
     * @memberof FindAllIntegrationsByFacilityId200Response
     */
    data?: Array<FacilityIntegration>;
}

/**
 * Check if a given object implements the FindAllIntegrationsByFacilityId200Response interface.
 */
export function instanceOfFindAllIntegrationsByFacilityId200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllIntegrationsByFacilityId200ResponseFromJSON(json: any): FindAllIntegrationsByFacilityId200Response {
    return FindAllIntegrationsByFacilityId200ResponseFromJSONTyped(json, false);
}

export function FindAllIntegrationsByFacilityId200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllIntegrationsByFacilityId200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(FacilityIntegrationFromJSON)),
    };
}

export function FindAllIntegrationsByFacilityId200ResponseToJSON(value?: FindAllIntegrationsByFacilityId200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(FacilityIntegrationToJSON)),
    };
}

